import { getPrefixedUrl } from '@source/utilities/get-prefixed-url';

const API_ENDPOINT = '/umbraco/api/ajaxform/submitdigitalbrochureform';

interface RequestBrochureData {
    additionalPdfs?: string;
    email: string;
    firstName: string;
    lastNamePrefix?: string;
    lastName: string;
    areaProjectId: string;
    projectPhaseId: string;
    propertyTypeId?: string | null;
    constructionNumberId?: string | null;
    fcToken: string;
    pageUrl: string; // Custom url that should be generated by BE
}

const requestBrochure = async ({
    additionalPdfs,
    email,
    firstName,
    lastNamePrefix,
    lastName,
    areaProjectId,
    projectPhaseId,
    propertyTypeId,
    constructionNumberId,
    pageUrl,
    fcToken,
}: RequestBrochureData) => {
    const data = {
        data: additionalPdfs,
        email,
        firstName,
        sufix: lastNamePrefix,
        lastName,
        pageUrl,
        areaId: areaProjectId,
        projectId: projectPhaseId,
        propertyId: propertyTypeId,
        constructionNumberId,
        FcToken: fcToken,
    };

    const response = await fetch(getPrefixedUrl(API_ENDPOINT), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    });

    const succeeded = await response.json();
    if (!response.ok || succeeded !== true) {
        throw new Error(`Brochure request failed with status ${response.status}.`);
    }
};

export { requestBrochure, RequestBrochureData };
